/**
 * Tabbed Media Section
 * Handles tab switching, image/video slides, and navigation
 */

(function() {
  if (window.TabbedMediaAssetLoaded) {
    if (typeof window.initTabbedMedia === 'function') {
      window.initTabbedMedia();
    }
    return;
  }

  window.TabbedMediaAssetLoaded = true;

  var MOBILE_MQ = '(max-width: 749px)';

  class TabbedMedia {
  constructor(section) {
    this.section = section;
    this.currentSlideIndex = 1;
    this.totalSlides = section.querySelectorAll('.banner-with-tabbing-main-image').length;
    this.isTransitioning = false;
    this.tabHeader = section.querySelector('.banner-with-tab-header');
    this.highlight = section.querySelector('.tab-highlight');
    this.leftArrow = section.querySelector('.tab-arrow--left');
    this.rightArrow = section.querySelector('.tab-arrow--right');
    this.imageContainer = section.querySelector('.banner-with-tabbing-main-image-content');
    this._onResize = null;
    this.isInViewport = false;
    this.viewportObserver = null;
    this._onVisibilityChange = () => this.syncViewportVideos();
    this.userPausedVideos = new WeakSet();

    this.init();
  }

  isMobileViewport() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  init() {
    this.section.querySelectorAll('.banner-with-tabbing-main-image-content').forEach((el) => {
      el.setAttribute('data-count', this.totalSlides);
    });

    const firstHeader = this.section.querySelector('.tab-header');
    if (firstHeader) firstHeader.classList.add('active');

    const firstTab = this.section.querySelector('.banner-tab');
    if (firstTab) firstTab.classList.add('active');

    const firstImage = this.section.querySelector('.banner-with-tabbing-main-image');
    if (firstImage) firstImage.classList.add('active');

    this.pauseAllVideos();
    // The visibility observer decides when the active video may load.

    this.updateArrowVisibility();
    this.updateHighlight();
    this.initBeforeAfter();

    if (this.tabHeader) {
      this.tabHeader.addEventListener('scroll', () => {
        this.updateArrowVisibility();
        this.updateHighlight();
      });
      setTimeout(() => {
        this.updateArrowVisibility();
        this.updateHighlight();
      }, 100);
    }

      this._onResize = () => {
        setTimeout(() => {
          this.updateArrowVisibility();
          this.updateHighlight();
          this.syncViewportVideos();
        }, 100);
      };
      window.addEventListener('resize', this._onResize);

    this.section.querySelectorAll('.tab-header').forEach((el) => {
      el.addEventListener('click', () => {
        if (this.isTransitioning) return;
        const newIndex = parseInt(el.getAttribute('data-id'), 10);
        if (newIndex !== this.currentSlideIndex) {
          this.currentSlideIndex = newIndex;
          this.activateSlideWithFade(this.currentSlideIndex);
          this.updateHighlight();
        }
      });
    });

    this.section.querySelectorAll('.nav-button').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.isTransitioning) return;
        const direction = parseInt(btn.getAttribute('data-direction'), 10);
        this.navigateSlide(direction);
      });
    });

    if (this.leftArrow) {
      this.leftArrow.addEventListener('click', () => this.scrollTabs(-200));
    }
    if (this.rightArrow) {
      this.rightArrow.addEventListener('click', () => this.scrollTabs(200));
    }

    this.section.querySelectorAll('.video-play-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-target');
        const video = this.section.querySelector('#' + id);
        if (video) {
          this.userPausedVideos.delete(video);
          this.playVideo(video);
        }

      });
    });

    this.section.querySelectorAll('.custom-video').forEach((v) => {
      v.addEventListener('play', () => {
        if (!this.canPlayVideo(v)) {
          v.pause();
          return;
        }
        const w = v.closest('.video-wrapper');
        if (w) {
          w.classList.add('is-playing');
          const b = w.querySelector('.video-play-btn');
          if (b) {
            b.classList.add('is-hidden');
            b.setAttribute('aria-hidden', 'true');
          }
        }
      });

      v.addEventListener('pause', () => {
        const w = v.closest('.video-wrapper');
        if (w) {
          w.classList.remove('is-playing');
          const b = w.querySelector('.video-play-btn');
          if (b) {
            b.classList.remove('is-hidden');
            b.removeAttribute('aria-hidden');
          }
        }
      });

      v.addEventListener('click', () => {
        if (v.paused || v.ended) {
          this.userPausedVideos.delete(v);
          this.playVideo(v);
        } else {
          this.userPausedVideos.add(v);
          v.pause();
        }
      });
    });

    this.section.setAttribute('tabindex', '0');
    this.section.addEventListener('keydown', (e) => {
      if (this.isTransitioning) return;
      if (e.key === 'ArrowLeft') {
        this.navigateSlide(-1);
      } else if (e.key === 'ArrowRight') {
        this.navigateSlide(1);
      }
    });
    this.initTouchEvents();
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    this.initVideoVisibility();
  }

  getVideosForSlide(slideEl) {
    if (!slideEl) return [];
    const isMobile = this.isMobileViewport();
    return Array.prototype.filter.call(slideEl.querySelectorAll('.custom-video'), (video) => {
      const wrap = video.closest('[data-viewport]');
      const viewport = wrap ? wrap.getAttribute('data-viewport') : 'all';
      if (viewport === 'mobile') return isMobile;
      if (viewport === 'desktop') return !isMobile;
      return true;
    });
  }

  pauseAllVideos() {
    this.section.querySelectorAll('.custom-video').forEach((video) => {
      try {
        if (!video.paused) video.pause();
      } catch (e) {}
    });
  }

  initVideoVisibility() {
    const target = this.imageContainer || this.section;
    if ('IntersectionObserver' in window) {
      this.viewportObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        this.isInViewport = entry.isIntersecting && entry.intersectionRatio > 0;
        this.syncViewportVideos();
      }, { rootMargin: '0px', threshold: 0 });
      this.viewportObserver.observe(target);
    } else {
      this._onViewportScroll = () => {
        const rect = target.getBoundingClientRect();
        this.isInViewport = rect.bottom > 0 && rect.top < window.innerHeight &&
          rect.right > 0 && rect.left < window.innerWidth;
        this.syncViewportVideos();
      };
      window.addEventListener('scroll', this._onViewportScroll, { passive: true });
      window.addEventListener('resize', this._onViewportScroll);
      this._onViewportScroll();
    }
  }

  canPlayVideo(video) {
    if (!this.isInViewport || document.hidden || !this.section.isConnected) return false;
    const slide = video.closest('.banner-with-tabbing-main-image');
    return !!slide && slide.classList.contains('active') &&
      this.getVideosForSlide(slide).includes(video);
  }

  loadVideoPoster(video) {
    const poster = video.getAttribute('data-poster');
    if (poster) {
      video.poster = poster;
      video.removeAttribute('data-poster');
    }
  }

  loadVideoSources(video) {
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      changed = true;
    });
    if (changed) {
      video.preload = 'metadata';
      video.load();
    }
  }

  playVideo(video) {
    if (!this.canPlayVideo(video)) return;
    this.loadVideoPoster(video);
    this.loadVideoSources(video);
    try {
      const result = video.play();
      if (result && typeof result.catch === 'function') {
        result.catch(function() {});
      }
    } catch (e) {}
  }

  activateSlideVideos(slideEl) {
    this.pauseAllVideos();
    if (!slideEl || !this.isInViewport || document.hidden) return;
    this.getVideosForSlide(slideEl).forEach((video) => this.loadVideoPoster(video));
    if (slideEl.getAttribute('data-video-autoplay') !== 'true') return;
    this.getVideosForSlide(slideEl).forEach((video) => {
      if (this.userPausedVideos.has(video)) return;
      video.muted = true;
      this.playVideo(video);
    });
  }

  syncViewportVideos() {
    const activeSlide = this.section.querySelector('.banner-with-tabbing-main-image.active');
    this.activateSlideVideos(activeSlide);
  }

  destroy() {
    this.isInViewport = false;
    this.pauseAllVideos();
    if (this.viewportObserver) this.viewportObserver.disconnect();
    if (this._onResize) window.removeEventListener('resize', this._onResize);
    if (this._onViewportScroll) {
      window.removeEventListener('scroll', this._onViewportScroll);
      window.removeEventListener('resize', this._onViewportScroll);
    }
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  }

  initBeforeAfter() {
    this.section.querySelectorAll('.before-after-slider').forEach((slider) => {
      if (slider.dataset.beforeAfterReady === 'true') return;
      slider.dataset.beforeAfterReady = 'true';

      const handle = slider.querySelector('.before-after__handle');
      const setPercent = (p) => {
        p = Math.max(0, Math.min(100, p));
        slider.style.setProperty('--drag-percent', p + '%');
        if (handle) handle.setAttribute('aria-valuenow', String(p));
      };
      const posFromEvent = (e) => {
        const rect = slider.getBoundingClientRect();
        const clientX = e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      };

      const disabledMobile = slider.getAttribute('data-mobile-disabled') === 'true';
      if (disabledMobile && this.isMobileViewport()) {
        setPercent(100);
        return;
      }

      const onMove = (e) => {
        e.preventDefault();
        setPercent(posFromEvent(e));
      };
      const endDrag = () => {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('touchmove', onMove);
        window.removeEventListener('mouseup', endDrag);
        window.removeEventListener('touchend', endDrag);
      };
      const startDrag = (e) => {
        e.preventDefault();
        setPercent(posFromEvent(e));
        window.addEventListener('mousemove', onMove);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('mouseup', endDrag);
        window.addEventListener('touchend', endDrag);
      };

      slider.addEventListener('mousedown', startDrag);
      slider.addEventListener('touchstart', startDrag, { passive: false });
      if (handle) {
        handle.addEventListener('keydown', (e) => {
          const v = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
          if (e.key === 'ArrowLeft') setPercent(v - 5);
          else if (e.key === 'ArrowRight') setPercent(v + 5);
        });
      }
    });
  }

  updateArrowVisibility() {
    if (!this.tabHeader || !this.leftArrow || !this.rightArrow) return;

    if (window.innerWidth <= 767) {
      const scrollWidth = this.tabHeader.scrollWidth;
      const clientWidth = this.tabHeader.clientWidth;
      const scrollLeft = this.tabHeader.scrollLeft;

      if (scrollWidth > clientWidth) {
        if (scrollLeft <= 0) {
          this.leftArrow.classList.add('hidden');
        } else {
          this.leftArrow.classList.remove('hidden');
        }

        if (scrollLeft >= scrollWidth - clientWidth - 1) {
          this.rightArrow.classList.add('hidden');
        } else {
          this.rightArrow.classList.remove('hidden');
        }
      } else {
        this.leftArrow.classList.add('hidden');
        this.rightArrow.classList.add('hidden');
      }
    } else {
      this.leftArrow.classList.add('hidden');
      this.rightArrow.classList.add('hidden');
    }
  }

  scrollTabs(amount) {
    if (this.tabHeader) {
      this.tabHeader.scrollBy({
        left: amount,
        behavior: 'smooth',
      });
    }
  }

  navigateSlide(direction) {
    let newIndex = this.currentSlideIndex + direction;
    if (newIndex > this.totalSlides) {
      this.currentSlideIndex = 1;
    } else if (newIndex < 1) {
      this.currentSlideIndex = this.totalSlides;
    } else {
      this.currentSlideIndex = newIndex;
    }
    this.activateSlideWithFade(this.currentSlideIndex);
  }

  activateSlideWithFade(slideIndex) {
    this.isTransitioning = true;

    const currentImage = this.section.querySelector('.banner-with-tabbing-main-image.active');
    const currentTab = this.section.querySelector('.banner-tab.active');
    const currentHeader = this.section.querySelector('.tab-header.active');

    this.pauseAllVideos();

    if (currentImage) currentImage.classList.remove('active');
    if (currentTab) currentTab.classList.remove('active');
    if (currentHeader) currentHeader.classList.remove('active');

    const newImage = this.section.querySelector(
      '.banner-with-tabbing-main-image[data-id="' + slideIndex + '"]'
    );
    const newTab = this.section.querySelector('.banner-tab[data-id="' + slideIndex + '"]');
    const newHeader = this.section.querySelector('.tab-header[data-id="' + slideIndex + '"]');

    setTimeout(() => {
      if (newImage) newImage.classList.add('active');
      if (newTab) newTab.classList.add('active');
      if (newHeader) newHeader.classList.add('active');

      this.activateSlideVideos(newImage);

      setTimeout(() => this.updateArrowVisibility(), 50);
      setTimeout(() => this.updateHighlight(), 50);
      setTimeout(() => {
        this.isTransitioning = false;
      }, 300);
    }, 50);
  }

  updateHighlight() {
    try {
      if (!this.highlight || !this.tabHeader) return;
      const active = this.section.querySelector('.tab-header.active');
      if (!active) return;
      const left = active.offsetLeft - this.tabHeader.scrollLeft;
      const width = active.offsetWidth;
      this.highlight.style.width = width + 'px';
      this.highlight.style.transform = 'translateX(' + left + 'px)';
    } catch (e) {}
  }

  initTouchEvents() {
    if (!this.imageContainer) return;
    let startX = 0;
    let startY = 0;
    let dx = 0;
    let dy = 0;
    const threshold = 50;

    const onStart = (e) => {
      if (this.isTransitioning) return;
      if (e.target && e.target.closest && e.target.closest('.before-after-slider')) return;
      const t = e.touches && e.touches[0] ? e.touches[0] : null;
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      dx = 0;
      dy = 0;
    };

    const onMove = (e) => {
      const t = e.touches && e.touches[0] ? e.touches[0] : null;
      if (!t) return;
      dx = t.clientX - startX;
      dy = t.clientY - startY;
    };

    const onEnd = () => {
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) >= threshold) {
        if (dx < 0) {
          this.navigateSlide(1);
        } else {
          this.navigateSlide(-1);
        }
      }
    };

    this.imageContainer.addEventListener('touchstart', onStart, { passive: true });
    this.imageContainer.addEventListener('touchmove', onMove, { passive: true });
    this.imageContainer.addEventListener('touchend', onEnd, { passive: true });
  }
  }

  function initTabbedMedia(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sections = scope.querySelectorAll('.banner-with-tabbing-content');

    sections.forEach((section) => {
      if (section.dataset.tabbedMediaInitialized === 'true') return;
      section.dataset.tabbedMediaInitialized = 'true';
      section.tabbedMediaInstance = new TabbedMedia(section);
    });
  }

  window.TabbedMedia = TabbedMedia;
  window.initTabbedMedia = initTabbedMedia;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      initTabbedMedia();
    });
  } else {
    initTabbedMedia();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.banner-with-tabbing-content');
      if (section) {
        initTabbedMedia(event.target);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.banner-with-tabbing-content');
      if (section) {
        if (section.tabbedMediaInstance) section.tabbedMediaInstance.destroy();
        delete section.tabbedMediaInstance;
        delete section.dataset.tabbedMediaInitialized;
      }
    });
  }
})();
